/**
 * Quiz page – form UI, validation, submit and redirect to results.
 * Loaded only on page.quiz template.
 * Depends on quiz-engine.js (window.MillsQuizEngine).
 */
(function () {
  "use strict";

  var Engine = window.MillsQuizEngine;
  if (!Engine || !Engine.VALUES) {
    if (typeof console !== "undefined" && console.warn) {
      console.warn("quiz-page.js: MillsQuizEngine not loaded; quiz UI disabled.");
    }
    return;
  }
  var Values = Engine.VALUES;

  /* Maps logical field names to #id selectors for the quiz form DOM. */
  var SELECTORS = {
    wrapper: "#quiz-wrapper",
    introContent: "#intro-content",
    quizContent: "#quiz-content",
    form: "#quiz-form",
    formButton: "#quiz-form-button",
    nameInput: "#quiz-form-name",
    nameNext: "#quiz-form-name-next",
    nameRow: "#quiz-form-name-row",
    genderInput: "#quiz-form-gender",
    genderRow: "#quiz-form-gender-row",
    castrationInput: "#quiz-form-castration",
    castrationRow: "#quiz-form-castration-row",
    weightInput: "#quiz-form-weight",
    weightNext: "#quiz-form-weight-next",
    weightRow: "#quiz-form-weight-row",
    ageInput: "#quiz-form-age",
    ageNext: "#quiz-form-age-next",
    ageRow: "#quiz-form-age-row",
    activityInput: "#quiz-form-activity",
    activityRow: "#quiz-form-activity-row",
    bodyInput: "#quiz-form-body",
    bodyRow: "#quiz-form-body-row",
    sensitivitiesInput: "#quiz-form-sensitivities",
    sensitivitiesRow: "#quiz-form-sensitivities-row",
    sensitivitiesDescInput: "#quiz-form-sensitivities-desc",
    sensitivitiesDescRow: "#quiz-form-sensitivities-desc-row",
    proteinInput: "#quiz-form-protein",
    proteinRow: "#quiz-form-protein-row",
    proteinDescInput: "#quiz-form-protein-desc",
    proteinDescRow: "#quiz-form-protein-desc-row",
  };

  /**
   * Ordered wizard steps (linear part + keys for detail rows).
   * row / input values are keys on SELECTORS.
   */
  var STEPS = [
    { key: "name", row: "nameRow", input: "nameInput", nextKey: "gender" },
    { key: "gender", row: "genderRow", input: "genderInput", nextKey: "castration" },
    { key: "castration", row: "castrationRow", input: "castrationInput", nextKey: "weight" },
    { key: "weight", row: "weightRow", input: "weightInput", nextKey: "age" },
    { key: "age", row: "ageRow", input: "ageInput", nextKey: "activity" },
    { key: "activity", row: "activityRow", input: "activityInput", nextKey: "body" },
    { key: "body", row: "bodyRow", input: "bodyInput", nextKey: "sensitivities" },
    { key: "sensitivities", row: "sensitivitiesRow", input: "sensitivitiesInput", nextKey: "sensitivities_desc_or_protein" },
    { key: "sensitivities_desc", row: "sensitivitiesDescRow", input: "sensitivitiesDescInput", parentKey: "sensitivities", nextKey: "protein" },
    { key: "protein", row: "proteinRow", input: "proteinInput", nextKey: "protein_desc_or_end" },
    { key: "protein_desc", row: "proteinDescRow", input: "proteinDescInput", parentKey: "protein", nextKey: null },
  ];

  var LINEAR_NEXT_ROW_KEY = { gender: "castrationRow", castration: "weightRow", weight: "ageRow", age: "activityRow", activity: "bodyRow", body: "sensitivitiesRow" };

  /**
   * Wrapper blocks for yes/no detail (multi-select) — single source for toggles / render.
   * Use with toggleEl(); not on $els (class-based regions, not single elements).
   */
  var DETAIL_SECTION = {
    sensitivities: ".of-sensitivities-desc",
    protein: ".of-protein-desc",
  };

  /* CSS class names used for wizard state and visibility. */
  var CLS = {
    active: "active",
    done: "done",
    show: "show",
    disabled: "disabled",
    hidden: "hidden",
  };

  /** Step keys where renderWizard must call applyTitles when painting done rows from state. */
  var STEP_KEYS_NEED_APPLY_TITLES = { name: true, gender: true };

  /** Hebrew UI strings for castration, age suffix, and option labels, keyed by gender value from the engine. */
  var GENDER_TEXT = {
    "זכר": {
      castTitle: "מעוקר / לא מעוקר",
      ageSuffix: "בן",
      castOpt: "מעוקר",
      noCastOpt: "לא מעוקר",
      petWord: "כלב",
    },
    "נקבה": {
      castTitle: "מעוקרת / לא מעוקרת",
      ageSuffix: "בת",
      castOpt: "מעוקרת",
      noCastOpt: "לא מעוקרת",
      petWord: "כלבה",
    },
  };

  /** Display labels for activity hidden values (done row / summary). */
  var ACTIVITY_LABELS = {};
  ACTIVITY_LABELS[Values.ACTIVITY_INACTIVE] = "ממוצע";
  ACTIVITY_LABELS[Values.ACTIVITY_ACTIVE] = "ספורטיבי";
  ACTIVITY_LABELS[Values.ACTIVITY_VERY] = "נינג׳ה";

  var RESULTS_URL = "/pages/results";

  var ROW_ID_TO_STEP_KEY = {};
  /** Maps quiz hidden/text input `id` (no #) to STEPS[].key for syncing quizState from DOM. */
  var INPUT_ID_TO_STEP_KEY = {};
  /** Per step key: rowKey / inputKey on SELECTORS, optional parentKey (detail rows). */
  var STEP_META_BY_KEY = {};

  for (var sri = 0; sri < STEPS.length; sri++) {
    var st = STEPS[sri];
    var rowSelStr = SELECTORS[st.row];
    ROW_ID_TO_STEP_KEY[rowSelStr.slice(1)] = st.key;
    var inputSelStr = SELECTORS[st.input];
    INPUT_ID_TO_STEP_KEY[inputSelStr.slice(1)] = st.key;
    STEP_META_BY_KEY[st.key] = {
      rowKey: st.row,
      inputKey: st.input,
      parentKey: st.parentKey || null,
    };
  }

  /**
   * Cached jQuery objects keyed like SELECTORS (filled in cacheDomReferences).
   * Rule: use $els for stable nodes; keep SELECTORS strings for Engine APIs, delegated .on(selector),
   *       $(el).is(SELECTORS...), and dynamic composition only when no cached node exists.
   */
  var $els = {};

  /** Central snapshot of quiz field values; kept in sync with inputs (see readStateFromForm, bindQuizEvents). */
  var quizState = {};

  function cacheDomReferences() {
    for (var k in SELECTORS) {
      if (Object.prototype.hasOwnProperty.call(SELECTORS, k)) {
        $els[k] = $(SELECTORS[k]);
      }
    }
  }

  /** Returns true if v is non-null, non-undefined, and non-empty after trim (for strings). */
  function hasValue(v) {
    if (v === null || v === undefined) return false;
    if (typeof v === "string") return v.trim() !== "";
    return true;
  }

  /** Parses integer from input string; returns NaN if invalid. */
  function toInt(raw) {
    return parseInt(String(raw || "").trim(), 10);
  }

  /** Enable or disable the submit button (class + disabled property). */
  function setSubmitEnabled(enabled) {
    $els.formButton[enabled ? "removeClass" : "addClass"](CLS.disabled).prop("disabled", !enabled);
  }

  /** Returns the gender-specific label set for the given gender, defaulting to male. */
  function getGenderText(gender) {
    return GENDER_TEXT[gender] || GENDER_TEXT[Values.GENDER_MALE];
  }

  /** Shows or hides a jQuery-matched element using CLS.hidden. */
  function toggleEl(selector, show) {
    $(selector)[show ? "removeClass" : "addClass"](CLS.hidden);
  }

  /** Builds the collapsed-row summary text as "label - answer". */
  function doneTitle(label, answer) {
    return String(label) + " - " + String(answer);
  }

  /** Step keys whose form values are trimmed in readStateFromForm. */
  var TRIM_FIELDS = { name: 1, sensitivities_desc: 1, protein_desc: 1 };

  /** Maps an input element's `id` to its quiz step key, or null. */
  function getStepKeyFromInputId(domId) {
    return domId ? INPUT_ID_TO_STEP_KEY[domId] || null : null;
  }

  /** Updates quizState for one input (same trim rules as readStateFromForm). */
  function setQuizStateFromInput(el) {
    var key = getStepKeyFromInputId(el.id);
    if (!key) return;
    var raw = $(el).val() || "";
    quizState[key] = TRIM_FIELDS[key] ? raw.trim() : raw;
  }

  /** Rebuilds quizState from all STEPS inputs (also assigns module quizState). */
  function readStateFromForm() {
    var state = {};
    for (var i = 0; i < STEPS.length; i++) {
      var key = STEPS[i].key;
      var raw = $els[STEPS[i].input].val() || "";
      state[key] = TRIM_FIELDS[key] ? raw.trim() : raw;
    }
    quizState = state;
    return state;
  }

  /**
   * Single source of truth for done-row summary text for a given step key.
   * @param {string} stepKey — e.g. "name", "gender", "sensitivities_desc"
   * @param {object} state — quiz field snapshot (quizState or readStateFromForm())
   */
  function getStepSummary(stepKey, state) {
    var name = state.name || "";
    var gender = state.gender;
    switch (stepKey) {
      case "name":
        return name;
      case "gender":
        return hasValue(state.gender) ? doneTitle("המין של " + name, state.gender) : "";
      case "castration":
        return hasValue(state.castration)
          ? castrationDoneLine(name, gender, state.castration)
          : "";
      case "weight":
        return hasValue(state.weight) ? doneTitle("המשקל של " + name, state.weight + " ק״ג") : "";
      case "age":
        return hasValue(state.age) ? ageDoneLine(name, gender, state.age) : "";
      case "activity":
        return hasValue(state.activity)
          ? doneTitle("פעילות גופנית", activityLabel(state.activity))
          : "";
      case "body":
        return hasValue(state.body) ? doneTitle("מבנה הגוף של " + name, state.body) : "";
      case "sensitivities":
        return yesNoDetailParentSummary(state, "sensitivities");
      case "sensitivities_desc":
      case "protein_desc":
        return "";
      case "protein":
        return yesNoDetailParentSummary(state, "protein");
      default:
        return "";
    }
  }

  /** Updates all dynamic question labels in the form that depend on pet name and gender. */
  function applyTitles(name, gender) {
    var g = gender ? getGenderText(gender) : GENDER_TEXT[Values.GENDER_MALE];
    $(".title-gender").text("המין של " + name);
    $(".title-type").text("הסוג של " + name);
    $(".title-castration").text(name + " " + g.castTitle);
    $(".title-weight").text("המשקל של " + name);
    $(".title-age").text(name + " " + g.ageSuffix);
    $(".title-body").text("מבנה הגוף של " + name);
    $("#dog-option-title").text(g.petWord);
    $("#castration-option-title").text(g.castOpt);
    $("#no-castration-option-title").text(g.noCastOpt);
  }

  /** Formats numeric age into a short Hebrew phrase for display (e.g. years). */
  function formatAgeTitle(age) {
    if (age == 0 || age === "0") return "שנה";
    if (age == 1 || age === "1") return "1 שנה";
    return age + " שנים";
  }

  /** Builds the done-row line for castration, including pet name and female-specific wording when needed. */
  function castrationDoneLine(name, gender, castration) {
    if (gender === Values.GENDER_FEMALE) {
      return name + " " + (castration === Values.CASTRATION_YES ? "מעוקרת" : "לא מעוקרת");
    }
    if (gender === Values.GENDER_MALE) {
      return name + " " + (castration === Values.CASTRATION_YES ? "מעוקר" : "לא מעוקר");
    }
    return name + " " + castration;
  }

  /** Builds the done-row line for age: name + gender suffix + age phrase. */
  function ageDoneLine(name, gender, ageVal) {
    return name + " " + getGenderText(gender).ageSuffix + " " + formatAgeTitle(ageVal);
  }

  /** Maps activity level value to a short Hebrew label for done-row text. */
  function activityLabel(activity) {
    return ACTIVITY_LABELS[activity] || "ממוצע";
  }

  /** Formats a comma-separated stored value for display with spaces after commas. */
  function formatCsvListDoneTitle(raw) {
    return String(raw || "").replace(/,/g, ", ");
  }

  /**
   * Config for unified parent-row summary (yes/no + optional CSV detail).
   * kind: "sensitivities" | "protein"
   */
  var YES_NO_DETAIL_SUMMARY = {
    sensitivities: {
      parentKey: "sensitivities",
      descKey: "sensitivities_desc",
      label: "רגישויות",
      filledPrefix: "קיימות רגישויות: ",
    },
    protein: {
      parentKey: "protein",
      descKey: "protein_desc",
      label: "העדפות חלבון",
      filledPrefix: "העדפות חלבון: ",
    },
  };

  /**
   * One-line summary for a yes/no parent step with optional multi-select detail (sensitivities or protein).
   */
  function yesNoDetailParentSummary(state, kind) {
    var c = YES_NO_DETAIL_SUMMARY[kind];
    if (!c) return "";
    var parentVal = state[c.parentKey];
    var descVal = state[c.descKey];
    if (!hasValue(parentVal)) return "";
    if (parentVal === Values.NO_EXISTS) {
      return doneTitle(c.label, Values.NO_EXISTS);
    }
    if (!hasValue(descVal)) {
      return doneTitle(c.label, Values.YES_EXISTS);
    }
    return c.filledPrefix + formatCsvListDoneTitle(descVal);
  }

  /**
   * Full yes/no + optional CSV detail flow (parent row, detail section, desc row, submit rules).
   * Keys match YES_NO_DETAIL_SUMMARY (labelKey).
   */
  var YES_NO_DETAIL_FLOW = {
    sensitivities: {
      labelKey: "sensitivities",
      inputSel: "sensitivitiesInput",
      rowSel: "sensitivitiesRow",
      detailSection: DETAIL_SECTION.sensitivities,
      descInputSel: "sensitivitiesDescInput",
      descRowSel: "sensitivitiesDescRow",
      descFieldName: "sensitivities_desc",
      hideWhileDetailActive: "proteinRow",
      showWhenNo: "proteinRow",
      disableSubmitOnYes: false,
      descChange: {
        inputSel: "sensitivitiesDescInput",
        targetRowWhenFilled: "proteinRow",
        toggleSubmitDisabled: false,
      },
    },
    protein: {
      labelKey: "protein",
      inputSel: "proteinInput",
      rowSel: "proteinRow",
      detailSection: DETAIL_SECTION.protein,
      descInputSel: "proteinDescInput",
      descRowSel: "proteinDescRow",
      descFieldName: "protein_desc",
      hideWhileDetailActive: null,
      showWhenNo: null,
      disableSubmitOnYes: true,
      descChange: {
        inputSel: "proteinDescInput",
        targetRowWhenFilled: null,
        toggleSubmitDisabled: true,
      },
    },
  };

  /**
   * Per detail step key: parent field + renderWizard behavior (detail-pair strategy).
   * Complements STEPS / STEP_META_BY_KEY — keeps branching out of renderWizardDetailBranch.
   */
  var DETAIL_PAIR_META = {
    sensitivities_desc: {
      parentKey: "sensitivities",
      summaryKind: "sensitivities",
      detailSection: DETAIL_SECTION.sensitivities,
      parentRowKey: "sensitivitiesRow",
      disableSubmitOnPendingDesc: false,
    },
    protein_desc: {
      parentKey: "protein",
      summaryKind: "protein",
      detailSection: DETAIL_SECTION.protein,
      parentRowKey: "proteinRow",
      disableSubmitOnPendingDesc: true,
    },
  };

  /** form-row id (no #) → "sensitivities" | "protein" for pair edit / hide sections. */
  var PAIR_KIND_FROM_ROW_ID = {};
  (function initPairRowIdMap() {
    function reg(rowKey, kind) {
      PAIR_KIND_FROM_ROW_ID[SELECTORS[rowKey].slice(1)] = kind;
    }
    reg("sensitivitiesRow", "sensitivities");
    reg("sensitivitiesDescRow", "sensitivities");
    reg("proteinRow", "protein");
    reg("proteinDescRow", "protein");
  })();

  /** Builds opts object for onYesNoDetailChange from YES_NO_DETAIL_FLOW. */
  function buildYesNoDetailChangeOpts(kind) {
    var f = YES_NO_DETAIL_FLOW[kind];
    return {
      inputSel: SELECTORS[f.inputSel],
      rowSel: SELECTORS[f.rowSel],
      labelKey: f.labelKey,
      detailClass: f.detailSection,
      detailRowSel: SELECTORS[f.descRowSel],
      detailInputSel: SELECTORS[f.descInputSel],
      detailFieldName: f.descFieldName,
      hideWhileDetailActive: f.hideWhileDetailActive ? SELECTORS[f.hideWhileDetailActive] : null,
      showWhenNo: f.showWhenNo ? SELECTORS[f.showWhenNo] : null,
      disableSubmitOnYes: f.disableSubmitOnYes,
      rowElKey: f.rowSel,
      parentInputElKey: f.inputSel,
      descRowElKey: f.descRowSel,
      descInputElKey: f.descInputSel,
    };
  }

  function getPairKindFromRowId(rowId) {
    return rowId ? PAIR_KIND_FROM_ROW_ID[rowId] || null : null;
  }

  /** Applies protein-row active class + submit state from desc CSV (shared by sensitivities_desc / protein_desc flows). */
  function applyDetailDescChange(opts) {
    var v = $(opts.inputSel).val();
    var filled = hasValue(v);
    if (opts.targetRowWhenFilled) {
      $(opts.targetRowWhenFilled)[filled ? "addClass" : "removeClass"](CLS.active);
    }
    if (opts.toggleSubmitDisabled) {
      setSubmitEnabled(filled);
    }
  }

  /** Runs shared desc-CSV handler + updates parent done-row title from YES_NO_DETAIL_FLOW. */
  function handleDetailCsvChange(pairKind) {
    var flow = YES_NO_DETAIL_FLOW[pairKind];
    var dc = flow.descChange;
    applyDetailDescChange({
      inputSel: SELECTORS[dc.inputSel],
      targetRowWhenFilled: dc.targetRowWhenFilled ? SELECTORS[dc.targetRowWhenFilled] : null,
      toggleSubmitDisabled: dc.toggleSubmitDisabled,
    });
    $els[flow.rowSel].find(".done-row .title").text(yesNoDetailParentSummary(quizState, flow.labelKey));
  }

  /** Shows sensitivities/protein detail blocks only when the parent hidden input equals YES_EXISTS. */
  function restoreDetailSectionsVisibility() {
    toggleEl(DETAIL_SECTION.sensitivities, $els.sensitivitiesInput.val() === Values.YES_EXISTS);
    toggleEl(DETAIL_SECTION.protein, $els.proteinInput.val() === Values.YES_EXISTS);
  }

  /** Marks the current row done, sets its summary text, activates the next incomplete row, and syncs detail visibility. */
  function completeWizardStep($currentRow, doneTitleText, $nextRow) {
    $currentRow.find(".done-row .title").text(doneTitleText);
    $currentRow.removeClass(CLS.active).addClass(CLS.done);
    if ($nextRow.length && !$nextRow.hasClass(CLS.done)) {
      $nextRow.addClass(CLS.active);
    }
    restoreDetailSectionsVisibility();
  }

  /** Completes a step using getStepSummary(stepKey) from current form state. */
  function completeWizardStepWithKey($currentRow, stepKey, $nextRow) {
    completeWizardStep($currentRow, getStepSummary(stepKey, quizState), $nextRow);
  }

  function completeLinearStep(stepKey) {
    var meta = STEP_META_BY_KEY[stepKey];
    completeWizardStepWithKey($els[meta.rowKey], stepKey, $els[LINEAR_NEXT_ROW_KEY[stepKey]]);
  }

  /** While the user types the pet name, updates applyTitles and all completed done-rows that embed the name. */
  function refreshDoneRowTitlesForName() {
    var state = quizState;
    if (!state.name) return;
    applyTitles(state.name, state.gender);
    var keys = ["name", "gender", "castration", "weight", "age", "body"];
    for (var i = 0; i < keys.length; i++) {
      var k = keys[i];
      var $row = $els[STEP_META_BY_KEY[k].rowKey];
      if ($row.hasClass(CLS.done)) {
        var summary = getStepSummary(k, state);
        if (summary) $row.find(".done-row .title").text(summary);
      }
    }
  }

  /** Writes multi-select chip state to the hidden CSV field and fires change. */
  function syncDescMultiSelectRowToHidden($descRow, $hiddenInput) {
    var vals = [];
    $descRow.find(".options .option").each(function () {
      if ($(this).hasClass(CLS.active)) {
        vals.push($(this).attr("data-val"));
      }
    });
    $hiddenInput.val(vals.join(",")).trigger("change");
  }

  /** Clears a multi-select detail row, its done summary, localStorage field, and row classes. */
  function clearDetailState($input, $row, fieldName) {
    $input.val("");
    $row.find(".options.multiple .option").removeClass(CLS.active);
    $row.find(".done-row .title").text("");
    Engine.persistFlatQuizField(fieldName, "");
    quizState[fieldName] = "";
    $row.removeClass(CLS.active).removeClass(CLS.done);
  }

  /** After loading draft data, clears detail fields if the parent yes/no answer does not require them. */
  function sanitizeDescFieldsAfterRestore() {
    if ($els.sensitivitiesInput.val() !== Values.YES_EXISTS)
      clearDetailState($els.sensitivitiesDescInput, $els.sensitivitiesDescRow, "sensitivities_desc");
    if ($els.proteinInput.val() !== Values.YES_EXISTS)
      clearDetailState($els.proteinDescInput, $els.proteinDescRow, "protein_desc");
  }

  /** Copies flat quiz object properties into the matching form inputs. */
  function applySerializedQuizFieldsToForm(d) {
    if (!d || typeof d !== "object") return;
    for (var i = 0; i < STEPS.length; i++) {
      var v = d[STEPS[i].key];
      if (v == null) continue;
      $els[STEPS[i].input].val(v);
    }
  }

  /** Syncs single-select .option.active classes from a hidden input value within its row. */
  function syncRegOptionsFromHidden($input) {
    var val = $input.val();
    if (!val) return;
    var $opts = $input.closest(".form-row").find(".options.reg .option");
    $opts.removeClass(CLS.active);
    $opts.filter('[data-val="' + val + '"]').addClass(CLS.active);
  }

  /** Syncs multi-select .option.active classes from a CSV hidden input within its row. */
  function syncMultipleOptionsFromHidden($input) {
    var raw = $input.val() || "";
    var vals = Engine.splitCsvTrim(raw);
    var $opts = $input.closest(".form-row").find(".options.multiple .option");
    $opts.removeClass(CLS.active);
    for (var j = 0; j < vals.length; j++) {
      $opts.filter('[data-val="' + vals[j] + '"]').addClass(CLS.active);
    }
  }

  /**
   * renderWizard strategy for detail-pair steps (CSV under parent yes).
   * Returns null if not a detail step; "skip" | "done" otherwise.
   */
  function renderWizardDetailBranch(state, key, $row) {
    var meta = DETAIL_PAIR_META[key];
    if (!meta) return null;
    if (state[meta.parentKey] !== Values.YES_EXISTS) return "skip";
    if (!hasValue(state[key])) {
      toggleEl(meta.detailSection, true);
      $row.addClass(CLS.active);
      if (meta.disableSubmitOnPendingDesc) setSubmitEnabled(false);
      $els[meta.parentRowKey].find(".done-row .title").text(yesNoDetailParentSummary(state, meta.summaryKind));
      return "done";
    }
    toggleEl(meta.detailSection, false);
    $row.addClass(CLS.done);
    $els[meta.parentRowKey].find(".done-row .title").text(yesNoDetailParentSummary(state, meta.summaryKind));
    return "skip";
  }

  /**
   * Renders one non-detail step row from state: either opens it as active (empty) or marks done with summary.
   * Returns true if renderWizard should stop (first incomplete step found).
   */
  function renderWizardApplyNormalStep(state, key, $row) {
    if (!hasValue(state[key])) {
      $row.addClass(CLS.active);
      return true;
    }
    if (STEP_KEYS_NEED_APPLY_TITLES[key]) applyTitles(state.name, state.gender);
    $row.find(".done-row .title").text(getStepSummary(key, state));
    $row.addClass(CLS.done);
    return false;
  }

  /**
   * Renders one STEPS entry: detail-pair branch when applicable, otherwise normal row.
   * @returns {"stop"|"continue"} stop = first incomplete step reached; renderWizard exits.
   */
  function renderWizardStep(state, step) {
    var key = step.key;
    var $row = $els[step.row];
    var detailOutcome = renderWizardDetailBranch(state, key, $row);
    if (detailOutcome === "done") return "stop";
    if (detailOutcome === "skip") return "continue";
    if (renderWizardApplyNormalStep(state, key, $row)) return "stop";
    return "continue";
  }

  /**
   * Renders wizard UI from a state snapshot: active/done rows, done-row titles, detail visibility, submit enabled.
   */
  function renderWizard(state) {
    $els.form.find(".form-row").removeClass(CLS.active + " " + CLS.done);
    setSubmitEnabled(true);
    toggleEl(DETAIL_SECTION.sensitivities, false);
    toggleEl(DETAIL_SECTION.protein, false);

    for (var i = 0; i < STEPS.length; i++) {
      if (renderWizardStep(state, STEPS[i]) === "stop") return;
    }
  }

  /** Loads flat fields from engine, sanitizes, syncs option UI, shows quiz, and applies wizard state. Returns whether a draft existed. */
  function restoreQuizDraft() {
    var d = Engine.readFlatFields();
    if (!Engine.hasMeaningfulDraft(d)) return false;

    applySerializedQuizFieldsToForm(d);
    sanitizeDescFieldsAfterRestore();

    for (var si = 0; si < STEPS.length; si++) {
      var st = STEPS[si];
      if (st.key === "name" || st.key === "weight" || st.key === "age") continue;
      var $input = $els[st.input];
      if (st.parentKey) syncMultipleOptionsFromHidden($input);
      else syncRegOptionsFromHidden($input);
    }

    $els.introContent.removeClass(CLS.show).hide();
    $els.quizContent.show();
    $els.quizContent.addClass(CLS.show);
    renderWizard(readStateFromForm());
    return true;
  }

  /** Intro CTA: animated transition into quiz then scroll. */
  function onGoToQuiz() {
    $els.introContent.removeClass(CLS.show);
    setTimeout(function () {
      $els.introContent.hide();
      $els.quizContent.show();
    }, 450);
    setTimeout(function () {
      $els.quizContent.addClass(CLS.show);
      $("html,body").animate({ scrollTop: $els.quizContent.offset().top - 150 }, 1000, "easeInOutQuint");
    }, 550);
  }

  /** On name blur: if name row is active and name non-empty, completes the step and opens gender. */
  function advanceFromNameStepIfValid() {
    if (!$els.nameRow.hasClass(CLS.active)) return;
    var name = ($els.nameInput.val() || "").trim();
    if (!name) return;
    applyTitles(name, $els.genderInput.val());
    completeWizardStepWithKey($els.nameRow, "name", $els.genderRow);
  }

  /** Name "next" button: advances same as blur when name is non-empty. */
  function onNameNext() {
    advanceFromNameStepIfValid();
  }

  function advanceFromNumericStepIfValid($row, $input, persistKey, stepKey, $nextRow, isValidFn) {
    if (!$row.hasClass(CLS.active)) return;
    var raw = ($input.val() || "").trim();
    if (!isValidFn(raw)) return;
    Engine.persistFlatQuizField(persistKey, String(toInt(raw)));
    completeWizardStepWithKey($row, stepKey, $nextRow);
  }

  /** On age blur: validates age, persists, completes step and opens activity row. */
  function advanceFromAgeStepIfValid() {
    advanceFromNumericStepIfValid($els.ageRow, $els.ageInput, "age", "age", $els.activityRow, Engine.isValidAge);
  }

  /** On weight blur/next: validates weight, persists, completes step and opens age row. */
  function advanceFromWeightStepIfValid() {
    advanceFromNumericStepIfValid($els.weightRow, $els.weightInput, "weight", "weight", $els.ageRow, Engine.isValidWeight);
  }

  /** Delegated click: single-select option in an active row updates hidden input and triggers change. */
  function onRegOptionClick() {
    var val = $(this).attr("data-val");
    $(this).siblings(".option").removeClass(CLS.active);
    $(this).addClass(CLS.active);
    $(this).parents(".options").siblings("input").val(val).trigger("change");
  }

  /** Delegated click: toggles multi-select chip and syncs sensitivities_desc or protein_desc hidden input. */
  function onMultipleOptionClick() {
    $(this).toggleClass(CLS.active);
    if ($(this).closest($els.sensitivitiesDescRow).length) {
      syncDescMultiSelectRowToHidden($els.sensitivitiesDescRow, $els.sensitivitiesDescInput);
    } else if ($(this).closest($els.proteinDescRow).length) {
      syncDescMultiSelectRowToHidden($els.proteinDescRow, $els.proteinDescInput);
    }
  }

  /** Gender hidden input change: refresh titles and advance to castration. */
  function onGenderChange() {
    applyTitles($els.nameInput.val(), $els.genderInput.val());
    completeLinearStep("gender");
  }

  /** Castration hidden input change: complete step and open weight row. */
  function onCastrationChange() {
    completeLinearStep("castration");
  }

  /** Activity hidden input change: complete step and open body type row. */
  function onActivityChange() {
    completeLinearStep("activity");
  }

  /** Body type hidden input change: complete step and open sensitivities row. */
  function onBodyChange() {
    completeLinearStep("body");
  }

  /** Weight "next" button: validates and advances same as blur path. */
  function onWeightNext() {
    var raw = $els.weightInput.val();
    if (!Engine.isValidWeight(raw)) return;
    advanceFromWeightStepIfValid();
  }

  /** Age "next" button: validates and advances same as blur path. */
  function onAgeNext() {
    var raw = $els.ageInput.val();
    if (!Engine.isValidAge(raw)) return;
    advanceFromAgeStepIfValid();
  }

  /**
   * Updates the done-row title for a yes/no + optional detail step (sensitivities / protein).
   * @param {object} opts — same shape as onYesNoDetailChange
   * @param {object} state — quiz field snapshot (quizState)
   */
  function applyYesNoDetailDoneRowTitle(opts, state) {
    $els[opts.rowElKey].find(".done-row .title").text(yesNoDetailParentSummary(state, opts.labelKey));
  }

  /**
   * Applies active/done classes and detail sub-row visibility for yes/no + optional detail flow.
   * @param {object} opts — same shape as onYesNoDetailChange
   */
  function applyYesNoDetailRowClasses(opts) {
    var val = $els[opts.parentInputElKey].val();
    $els[opts.rowElKey].removeClass(CLS.active).addClass(CLS.done);
    if (val === Values.YES_EXISTS) {
      toggleEl(opts.detailClass, true);
      $els[opts.descRowElKey].addClass(CLS.active);
      if (opts.hideWhileDetailActive) {
        $(opts.hideWhileDetailActive).removeClass(CLS.active);
      }
      if (opts.disableSubmitOnYes) {
        setSubmitEnabled(false);
      }
    } else {
      clearDetailState($els[opts.descInputElKey], $els[opts.descRowElKey], opts.detailFieldName);
      toggleEl(opts.detailClass, false);
      $els[opts.descRowElKey].removeClass(CLS.active);
      if (opts.showWhenNo) {
        $(opts.showWhenNo).addClass(CLS.active);
      }
      if (opts.disableSubmitOnYes) {
        setSubmitEnabled(true);
      }
    }
  }

  /**
   * Shared handler for sensitivities and protein yes/no: sets done row, shows or clears detail sub-row,
   * optionally activates next row or submit disabled state.
   */
  function onYesNoDetailChange(opts) {
    var state = quizState;
    applyYesNoDetailDoneRowTitle(opts, state);
    applyYesNoDetailRowClasses(opts);
  }

  /** Sensitivities parent answer changed: branch to detail multi-select or protein row. */
  function onSensitivitiesChange() {
    onYesNoDetailChange(buildYesNoDetailChangeOpts("sensitivities"));
  }

  /** Protein preference answer changed: branch to protein detail or enable submit. */
  function onProteinChange() {
    onYesNoDetailChange(buildYesNoDetailChangeOpts("protein"));
  }

  /** Sensitivities detail CSV updated: show protein row when at least one option selected; unified parent title. */
  function onSensitivitiesDescChange() {
    handleDetailCsvChange("sensitivities");
  }

  /** Protein detail CSV updated: enable submit only when non-empty; unified parent title. */
  function onProteinDescChange() {
    handleDetailCsvChange("protein");
  }

  /** Blocks programmatic/nested clicks when submit is disabled. */
  function onSubmitButtonClick(e) {
    if ($els.formButton.hasClass(CLS.disabled)) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }
  }

  /** Maps a form-row DOM id (e.g. quiz-form-gender-row) to STEPS[].key. */
  function getStepKeyFromRowId(rowId) {
    return rowId ? ROW_ID_TO_STEP_KEY[rowId] || null : null;
  }

  /** True if the step has enough data to keep a done row with summary (aligned with renderWizard). */
  function getIsStepFilledForDoneRow(stepKey, state) {
    var meta = DETAIL_PAIR_META[stepKey];
    if (meta) {
      return state[meta.parentKey] === Values.YES_EXISTS && hasValue(state[stepKey]);
    }
    return hasValue(state[stepKey]);
  }

  /** Applies DOM for reopening a yes/no + detail pair for edit (from YES_NO_DETAIL_FLOW). */
  function applyPairOpenForEdit(pairKind) {
    var flow = YES_NO_DETAIL_FLOW[pairKind];
    $els[flow.rowSel].removeClass(CLS.done).addClass(CLS.active);
    var hasDetail = $els[flow.inputSel].val() === Values.YES_EXISTS;
    toggleEl(flow.detailSection, hasDetail);
    if (hasDetail) {
      $els[flow.descRowSel].removeClass(CLS.done).addClass(CLS.active);
    }
  }

  /** After clicking "change", closes active rows and restores done state on previously active rows. */
  function resetActiveRowsBeforeEdit($form, state) {
    var $prevActive = $form.find(".form-row." + CLS.active);
    $form.find(".form-row").removeClass(CLS.active);
    $prevActive.each(function () {
      var $pr = $(this);
      var sk = getStepKeyFromRowId($pr.attr("id"));
      if (!sk) return;
      if (getIsStepFilledForDoneRow(sk, state)) {
        $pr.addClass(CLS.done);
        var summary = getStepSummary(sk, state);
        if (summary) $pr.find(".done-row .title").text(summary);
      } else {
        $pr.removeClass(CLS.done);
        $pr.find(".done-row .title").text("");
      }
    });
  }

  function applyOpenSingleRowForEdit($row) {
    $row.removeClass(CLS.done).addClass(CLS.active);
  }

  /** Row id from the clicked .change → pair kind or null for linear steps. */
  function getEditTargetFromDoneRowClick($row) {
    return { pairKind: getPairKindFromRowId($row.attr("id")) };
  }

  function applyEditModeForPairKind(pairKind) {
    applyPairOpenForEdit(pairKind);
  }

  function applyEditModeForLinearRow($row) {
    applyOpenSingleRowForEdit($row);
  }

  /** Hides detail section wrappers not used by the pair being edited (pairKind null → hide both). */
  function applyDetailSectionsVisibilityForEdit(pairKind) {
    if (pairKind !== "sensitivities") toggleEl(DETAIL_SECTION.sensitivities, false);
    if (pairKind !== "protein") toggleEl(DETAIL_SECTION.protein, false);
  }

  function syncFlatFieldsAfterEditOpen() {
    Engine.syncAllFlatFromForm(SELECTORS.form);
  }

  /** Click .change on a done row: reopen that step (or sensitivities/protein pair) for edit. */
  function handleChangeDoneRowClick() {
    var $row = $(this).closest(".form-row");
    resetActiveRowsBeforeEdit($els.form, quizState);
    var target = getEditTargetFromDoneRowClick($row);
    if (target.pairKind) {
      applyEditModeForPairKind(target.pairKind);
    } else {
      applyEditModeForLinearRow($row);
    }
    applyDetailSectionsVisibilityForEdit(target.pairKind);
    syncFlatFieldsAfterEditOpen();
  }

  /** Validates age/weight, normalizes, saves quiz data and redirects to results page. */
  function onSubmit(e) {
    e.preventDefault();
    if ($els.formButton.hasClass(CLS.disabled)) return false;

    var formData = Engine.serializeForm($els.form);
    if (formData.age == 0 || formData.age === "0") formData.age = 1;
    if (formData.weight == 0 || formData.weight === "0") formData.weight = 1;
    var age = toInt(formData.age);
    var weight = toInt(formData.weight);
    if (!Engine.isValidAge(formData.age)) {
      $els.ageInput.focus();
      return false;
    }
    if (!Engine.isValidWeight(formData.weight)) {
      $els.weightInput.focus();
      return false;
    }
    formData.age = String(age);
    formData.weight = String(weight);
    formData.type = Values.PET_TYPE_DOG;

    Engine.syncAllFlatFromForm(SELECTORS.form);
    Engine.saveQuizDataSubFormat(formData);
    window.location.href = RESULTS_URL;
  }

  /** Persists flat field and syncs quizState for any input change (must run before step-specific change handlers). */
  function handleFormInputChange() {
    Engine.persistFlatFromInput(this);
    setQuizStateFromInput(this);
  }

  function handleFormInputBlur() {
    Engine.persistFlatFromInput(this);
    setQuizStateFromInput(this);
    if ($(this).is(SELECTORS.nameInput)) advanceFromNameStepIfValid();
    if ($(this).is(SELECTORS.ageInput)) advanceFromAgeStepIfValid();
    if ($(this).is(SELECTORS.weightInput)) advanceFromWeightStepIfValid();
  }

  function handleNameInput() {
    Engine.persistFlatQuizField("name", $(this).val());
    setQuizStateFromInput(this);
    refreshDoneRowTitlesForName();
  }

  function handleWeightAgeInput() {
    Engine.persistFlatFromInput(this);
    setQuizStateFromInput(this);
  }

  /** Attaches all delegated and direct event listeners for the quiz form. */
  function bindQuizEvents() {
    var $root = $els.wrapper;
    $root.on("click", ".go-to-quiz", onGoToQuiz);
    $root.on("click", ".form-row.active .options.reg .option", onRegOptionClick);
    $root.on("click", ".options.multiple .option", onMultipleOptionClick);

    /* Must run before delegated handlers below so quizState is fresh for completeWizardStepWithKey / getStepSummary. */
    $els.form.on("change", "input", handleFormInputChange);

    var bodyChangeHandlers = [
      [SELECTORS.genderInput, onGenderChange],
      [SELECTORS.castrationInput, onCastrationChange],
      [SELECTORS.activityInput, onActivityChange],
      [SELECTORS.bodyInput, onBodyChange],
      [SELECTORS.sensitivitiesInput, onSensitivitiesChange],
      [SELECTORS.sensitivitiesDescInput, onSensitivitiesDescChange],
      [SELECTORS.proteinInput, onProteinChange],
      [SELECTORS.proteinDescInput, onProteinDescChange],
    ];
    for (var bi = 0; bi < bodyChangeHandlers.length; bi++) {
      $els.form.on("change", bodyChangeHandlers[bi][0], bodyChangeHandlers[bi][1]);
    }

    $els.form.on("click", SELECTORS.nameNext, onNameNext);
    $els.form.on("click", SELECTORS.weightNext, onWeightNext);
    $els.form.on("click", SELECTORS.ageNext, onAgeNext);
    $els.form.on("click", SELECTORS.formButton, onSubmitButtonClick);
    $els.form.on("click", ".form-row .done-row .change", handleChangeDoneRowClick);

    $els.form.on("blur", "input[type=text], input[type=number]", handleFormInputBlur);
    $els.form.on("input", SELECTORS.nameInput, handleNameInput);
    $els.form.on("input", SELECTORS.weightInput + ", " + SELECTORS.ageInput, handleWeightAgeInput);
    $els.form.on("submit", onSubmit);
  }

  /** Module entry: binds events and restores draft. */
  function init() {
    if ($els.wrapper.length === 0) return;
    bindQuizEvents();
    if (!restoreQuizDraft()) {
      readStateFromForm();
    }
  }

  /* Boot when DOM is ready. */
  jQuery(document).ready(function () {
    cacheDomReferences();
    init();
  });
})();




